var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKOUT_USER_ERROR_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.CHECKOUT_USER_ERROR_FRAGMENT = (0, graphql_tag_1.default)`
  fragment CheckoutUserErrorFragment on CheckoutUserError {
    field
    message
    code
  }
`;